module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/BC4056-a532a70607879a4769e564c1f92ad49b.png";